
export const serviceNumberTypeConstants = {
    GET_SERVICE_NUMBER_TYPE_REQUEST: 'GET_SERVICE_NUMBER_TYPE_REQUEST',
    GET_SERVICE_NUMBER_TYPE_SUCCESS: 'GET_SERVICE_NUMBER_TYPE_SUCCESS',
    GET_SERVICE_NUMBER_TYPE_FAILURE: 'GET_SERVICE_NUMBER_TYPE_FAILURE',

    GET_SERVICE_NUMBER_TYPES_REQUEST: 'GET_SERVICE_NUMBER_TYPES_REQUEST',
    GET_SERVICE_NUMBER_TYPES_SUCCESS: 'GET_SERVICE_NUMBER_TYPES_SUCCESS',
    GET_SERVICE_NUMBER_TYPES_FAILURE: 'GET_SERVICE_NUMBER_TYPES_FAILURE',

    GET_SERVICE_NUMBER_TYPES_COVERAGE_REQUEST: 'GET_SERVICE_NUMBER_TYPES_COVERAGE_REQUEST',
    GET_SERVICE_NUMBER_TYPES_COVERAGE_SUCCESS: 'GET_SERVICE_NUMBER_TYPES_COVERAGE_SUCCESS',
    GET_SERVICE_NUMBER_TYPES_COVERAGE_FAILURE: 'GET_SERVICE_NUMBER_TYPES_COVERAGE_FAILURE',

    GET_SERVICE_NUMBER_TYPES_COVERAGE_COORDINATES_REQUEST: 'GET_SERVICE_NUMBER_TYPES_COVERAGE_COORDINATES_REQUEST',
    GET_SERVICE_NUMBER_TYPES_COVERAGE_COORDINATES_SUCCESS: 'GET_SERVICE_NUMBER_TYPES_COVERAGE_COORDINATES_SUCCESS',
    GET_SERVICE_NUMBER_TYPES_COVERAGE_COORDINATES_FAILURE: 'GET_SERVICE_NUMBER_TYPES_COVERAGE_COORDINATES_FAILURE',

    GET_SERVICE_NUMBER_TYPES_COVERAGE_CITIES_REQUEST: 'GET_SERVICE_NUMBER_TYPES_COVERAGE_CITIES_REQUEST',
    GET_SERVICE_NUMBER_TYPES_COVERAGE_CITIES_SUCCESS: 'GET_SERVICE_NUMBER_TYPES_COVERAGE_CITIES_SUCCESS',
    GET_SERVICE_NUMBER_TYPES_COVERAGE_CITIES_FAILURE: 'GET_SERVICE_NUMBER_TYPES_COVERAGE_CITIES_FAILURE',

    ADD_SERVICE_NUMBER_TYPE_REQUEST: 'ADD_SERVICE_NUMBER_TYPE_REQUEST',
    ADD_SERVICE_NUMBER_TYPE_SUCCESS: 'ADD_SERVICE_NUMBER_TYPE_SUCCESS',
    ADD_SERVICE_NUMBER_TYPE_FAILURE: 'ADD_SERVICE_NUMBER_TYPE_FAILURE',

    ADD_BULK_SERVICE_NUMBER_TYPE_REQUEST: 'ADD_BULK_SERVICE_NUMBER_TYPE_REQUEST',
    ADD_BULK_SERVICE_NUMBER_TYPE_SUCCESS: 'ADD_BULK_SERVICE_NUMBER_TYPE_SUCCESS',
    ADD_BULK_SERVICE_NUMBER_TYPE_FAILURE: 'ADD_BULK_SERVICE_NUMBER_TYPE_FAILURE',

    UPLOAD_FILE_SERVICE_NUMBER_TYPE_REQUEST: 'UPLOAD_FILE_SERVICE_NUMBER_TYPE_REQUEST',
    UPLOAD_FILE_SERVICE_NUMBER_TYPE_SUCCESS: 'UPLOAD_FILE_SERVICE_NUMBER_TYPE_SUCCESS',
    UPLOAD_FILE_SERVICE_NUMBER_TYPE_FAILURE: 'UPLOAD_FILE_SERVICE_NUMBER_TYPE_FAILURE',

    UPDATE_SERVICE_NUMBER_TYPE_REQUEST: 'UPDATE_SERVICE_NUMBER_TYPE_REQUEST',
    UPDATE_SERVICE_NUMBER_TYPE_SUCCESS: 'UPDATE_SERVICE_NUMBER_TYPE_SUCCESS',
    UPDATE_SERVICE_NUMBER_TYPE_FAILURE: 'UPDATE_SERVICE_NUMBER_TYPE_FAILURE'
};
